import { styled } from '@linaria/react';
const _exp = /*#__PURE__*/() => props => props.shrink ? '0px' : '167px';
const _exp2 = /*#__PURE__*/() => props => props.shrink ? '0px' : '150px';
const _exp3 = /*#__PURE__*/() => props => `var(--font-size-${props.fontSize ?? 'md'})`;
const _exp4 = /*#__PURE__*/() => props => props.padding ?? '10px';
const _exp5 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].border;
const _exp6 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].bgColor;
const _exp7 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].color;
const _exp8 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].hover.color;
const _exp9 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].hover.bgColor;
const _exp10 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].disabled?.border ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].border;
const _exp11 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].disabled?.color ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].color;
const _exp12 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].disabled?.bgColor ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].bgColor;
const _exp13 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].current?.border ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].border;
const _exp14 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].current?.color ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].color;
const _exp15 = /*#__PURE__*/() => props => ({
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
})[props.variant ?? 'function'].current?.bgColor ?? {
  function: {
    color: "#FFFFFF",
    bgColor: "var(--color-function)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#212359",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#ceced5",
      border: "none"
    },
    current: null
  },
  functionWeak: {
    color: "#08092D",
    bgColor: "var(--color-function-cv2)",
    border: "none",
    hover: {
      color: "#525581",
      bgColor: "#EAEAEC",
      border: "none"
    },
    disabled: null,
    current: {
      color: "#fff",
      bgColor: "#54556E",
      border: "none"
    }
  },
  primary: {
    color: "#FFFFFF",
    bgColor: "var(--color-secondary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#C05D69",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#efd9db",
      border: "none"
    },
    current: null
  },
  secondary: {
    color: "#FFFFFF",
    bgColor: "var(--color-primary)",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "var(--color-primary)",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#eee2cb",
      border: "none"
    },
    current: null
  },
  primaryWeak: {
    color: "#791010",
    bgColor: "#fff",
    border: "1px solid #791010",
    hover: {
      color: "#791010",
      bgColor: "#fff",
      border: "1px solid #791010"
    },
    disabled: null,
    current: {
      color: "#FFFFFF",
      bgColor: "#791010",
      border: "none"
    }
  },
  line: {
    color: "#FFFFFF",
    bgColor: "#34B35A",
    border: "none",
    hover: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    disabled: {
      color: "#FFFFFF",
      bgColor: "#34B35A",
      border: "none"
    },
    current: null
  },
  outline: {
    color: "#54556E",
    bgColor: "#fff",
    border: "1px solid #54556E",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  },
  navy: {
    color: "#fff",
    bgColor: "#08092D",
    border: "none",
    hover: {
      color: "#54556E",
      bgColor: "#fff",
      border: "none"
    },
    disabled: {
      color: "#54556E",
      bgColor: "#fff",
      border: "#54556E"
    },
    current: null
  }
}[props.variant ?? 'function'].bgColor;
export const Button = /*#__PURE__*/styled('button')({
  name: "Button",
  class: "b1ykri1t",
  propsAsIs: false,
  vars: {
    "b1ykri1t-0": [_exp()],
    "b1ykri1t-1": [_exp2()],
    "b1ykri1t-2": [_exp3()],
    "b1ykri1t-3": [_exp4()],
    "b1ykri1t-4": [_exp5()],
    "b1ykri1t-5": [_exp6()],
    "b1ykri1t-6": [_exp7()],
    "b1ykri1t-7": [_exp8()],
    "b1ykri1t-8": [_exp9()],
    "b1ykri1t-9": [_exp10()],
    "b1ykri1t-10": [_exp11()],
    "b1ykri1t-11": [_exp12()],
    "b1ykri1t-12": [_exp13()],
    "b1ykri1t-13": [_exp14()],
    "b1ykri1t-14": [_exp15()]
  }
});
export const ButtonGroup = /*#__PURE__*/styled('div')({
  name: "ButtonGroup",
  class: "b1xf3ipy",
  propsAsIs: false
});

require("./Button.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Button.tsx");